//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from "store/constants";

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------
const rubricInit = [];

export const rubrices = (state = rubricInit, action) => {
  switch (action.type) {
    case ActionTypes.rubric.getRubric:
      return action.payload;
    case ActionTypes.rubric.createRubric:
      return [...state, action.payload];
    case ActionTypes.rubric.rubricDelete:
      return state.filter((data) => data?.id !== action.payload);
    case ActionTypes.rubric.rubricEdit:
      const updated = state.map((element) => {
        if (element?.id === action?.payload?.id) {
          return action.payload.data;
        }
        return element;
      });
      return updated;
    case ActionTypes.rubric.rubricFail:
      return state;
    default:
      return state;
  }
};
